import styled from 'styled-components';

export const OptionTile = styled.div`
  margin: 0 0 0.5rem 0;
  padding: 1rem 1.25rem;
  color: ${Styles.color.black};
  background-color: ${Styles.color.cardBackground};
  border-radius: ${Styles.borderRadius};
  outline: ${Styles.color.tertiary};
  font-size: 0.9375rem;
  line-height: 1.75rem;
`;
